import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";

export class UserListStore extends ListStoreConstructor<any> {
  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getUserList(params).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        pollingInterval: 10000,
        sorters: {
          statusDate: "desc",
        },
      }
    );
  }
}
